import React, {Component, PropTypes} from 'react';
import {connect} from 'react-redux';
import actions from 'actions';

const {
  unsubscribeSaga
} = actions;

class Unsubscribe extends Component {

  constructor(props) {
    super(props);
    this.props.unsubscribe(this.props.location.query.token);
  }

  render() {
    return (
      <main className="site--width">
        <div className="container_content_unsubscribe">
          Your email address has been removed from the mailing list.<p> You can subscribe again in your profile.</p>
        </div>
      </main>
    )
  }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  unsubscribe: (token) => (dispatch(unsubscribeSaga(token)))
})

export default connect(mapStateToProps, mapDispatchToProps)(Unsubscribe);



// WEBPACK FOOTER //
// ./src/containers/Mail/Unsubscribe.js